import {XMarkIcon} from '@heroicons/react/24/solid';
import MapDataClean from './MapDataClean.jsx';
import MapDataExport from './MapDataExport.jsx';
import MapDataImport from './MapDataImport.jsx';
export default function MapDatabaseSidebar({open, onClose}){
    return (
        <div className={`w-96 ${open?'max-w-sm':'max-w-0'} transition-max-w duration-200 overflow-x-hidden relative flex flex-col bg-white`} >
            {open && (
                <div>
                    {/* <div className="overflow-x-hidden overflow-y-auto max-h-[85vh] border-t border-t-gray-100"> */} 
                    <div className='flex pr-4 border-b'>
                        <h3 className='text-2xl font-light m-4'>Database</h3>
                        <span className='flex-grow'></span>
                        {onClose && <button onClick={()=>onClose()}><XMarkIcon className='w-8 text-gray-400' /></button>}
                    </div>
                    <div className='max-h-[80vh] overflow-y-auto'>
                        <MapDataImport onClose={()=>onClose()} />
                        <hr className='m-4 border-black' />
                        <MapDataExport onClose={()=>onClose()} />
                        <hr className='m-4 border-black' />
                        <MapDataClean onClose={()=>onClose()} />
                    </div>
                </div>
            )}
        </div>
    );
}